// language=GraphQL
export const ALL_CONVERSION_PLATFORM_SUBMISSIONS_QUERY = `query Query($withConversion: Boolean = false, $withConversionTenant: Boolean = false, $withConversionTenantCms: Boolean = false, $withConversionTenantTravelTypes: Boolean = false, $withConversionTenantEmployees: Boolean = false, $withConversionTenantEmailConfig: Boolean = false, $withConversionTenantNewsletterProvider: Boolean = false, $withConversionTenantRedirects: Boolean = false, $withConversionTenantOnlinePaymentConfig: Boolean = false, $withConversionTenantRatioConfig: Boolean = false, $withConversionTenantContent: Boolean = false, $withConversionTenantPartnerTenants: Boolean = false) {
  conversionPlatformSubmissions: trackingConversionPlatformSubmissions {
    id
    conversion @include(if: $withConversion) {
      id
      sessionId
      conversionName
      conversionTime
      conversionValue
      conversionCurrency
      tourName
      tourId
      bookingId
      landingPageUrl
      source
      medium
      utmSource
      utmMedium
      utmCampaign
      utmTerm
      utmContent
      gclid
      gbraid
      msclkid
      fbclid
      ttclid
      scclid
      liFatId
      acquisitionTimestamp
      tenant @include(if: $withConversionTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withConversionTenantCms) {
          id
        }
        travelTypes @include(if: $withConversionTenantTravelTypes) {
          id
          name
          description
        }
        employees @include(if: $withConversionTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        emailConfig @include(if: $withConversionTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          previewTravelInterestTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withConversionTenantNewsletterProvider) {
          id
          provider
        }
        redirects @include(if: $withConversionTenantRedirects) {
          id
          fromType
          fromUrl
          toType
          toUrl
        }
        onlinePaymentConfig @include(if: $withConversionTenantOnlinePaymentConfig) {
          id
          enabled
          datatransMerchantId
          datatransMerchantPw
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withConversionTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withConversionTenantContent) {
          id
          bookingInsuranceInfo
          co2CompensationInfo
        }
        partnerTenants @include(if: $withConversionTenantPartnerTenants) {
          id
          filterCrossLinking
        }
      }
    }
    platform
    sentAt
    status
    errorMessage
  }
}`

// language=GraphQL
export const SINGLE_CONVERSION_PLATFORM_SUBMISSION_QUERY = `query Query($id: ID!, $withConversion: Boolean = false, $withConversionTenant: Boolean = false, $withConversionTenantCms: Boolean = false, $withConversionTenantTravelTypes: Boolean = false, $withConversionTenantEmployees: Boolean = false, $withConversionTenantEmailConfig: Boolean = false, $withConversionTenantNewsletterProvider: Boolean = false, $withConversionTenantRedirects: Boolean = false, $withConversionTenantOnlinePaymentConfig: Boolean = false, $withConversionTenantRatioConfig: Boolean = false, $withConversionTenantContent: Boolean = false, $withConversionTenantPartnerTenants: Boolean = false) {
  conversionPlatformSubmission: trackingConversionPlatformSubmission(id: $id) {
    id
    conversion @include(if: $withConversion) {
      id
      sessionId
      conversionName
      conversionTime
      conversionValue
      conversionCurrency
      tourName
      tourId
      bookingId
      landingPageUrl
      source
      medium
      utmSource
      utmMedium
      utmCampaign
      utmTerm
      utmContent
      gclid
      gbraid
      msclkid
      fbclid
      ttclid
      scclid
      liFatId
      acquisitionTimestamp
      tenant @include(if: $withConversionTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withConversionTenantCms) {
          id
        }
        travelTypes @include(if: $withConversionTenantTravelTypes) {
          id
          name
          description
        }
        employees @include(if: $withConversionTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        emailConfig @include(if: $withConversionTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          previewTravelInterestTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withConversionTenantNewsletterProvider) {
          id
          provider
        }
        redirects @include(if: $withConversionTenantRedirects) {
          id
          fromType
          fromUrl
          toType
          toUrl
        }
        onlinePaymentConfig @include(if: $withConversionTenantOnlinePaymentConfig) {
          id
          enabled
          datatransMerchantId
          datatransMerchantPw
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withConversionTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withConversionTenantContent) {
          id
          bookingInsuranceInfo
          co2CompensationInfo
        }
        partnerTenants @include(if: $withConversionTenantPartnerTenants) {
          id
          filterCrossLinking
        }
      }
    }
    platform
    sentAt
    status
    errorMessage
  }
}`

// language=GraphQL
export const CREATE_CONVERSION_PLATFORM_SUBMISSION_MUTATION = `
  mutation Mutation($input: CreateTrackingConversionPlatformSubmissionInput, $withConversion: Boolean = false, $withConversionTenant: Boolean = false, $withConversionTenantCms: Boolean = false, $withConversionTenantTravelTypes: Boolean = false, $withConversionTenantEmployees: Boolean = false, $withConversionTenantEmailConfig: Boolean = false, $withConversionTenantNewsletterProvider: Boolean = false, $withConversionTenantRedirects: Boolean = false, $withConversionTenantOnlinePaymentConfig: Boolean = false, $withConversionTenantRatioConfig: Boolean = false, $withConversionTenantContent: Boolean = false, $withConversionTenantPartnerTenants: Boolean = false) {
    conversionPlatformSubmission: createTrackingConversionPlatformSubmission(input: $input) {
      id
      conversion @include(if: $withConversion) {
        id
        sessionId
        conversionName
        conversionTime
        conversionValue
        conversionCurrency
        tourName
        tourId
        bookingId
        landingPageUrl
        source
        medium
        utmSource
        utmMedium
        utmCampaign
        utmTerm
        utmContent
        gclid
        gbraid
        msclkid
        fbclid
        ttclid
        scclid
        liFatId
        acquisitionTimestamp
        tenant @include(if: $withConversionTenant) {
          id
          name
          slug
          domain
          externalReference
          cms @include(if: $withConversionTenantCms) {
            id
          }
          travelTypes @include(if: $withConversionTenantTravelTypes) {
            id
            name
            description
          }
          employees @include(if: $withConversionTenantEmployees) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          emailConfig @include(if: $withConversionTenantEmailConfig) {
            id
            defaultInternalRecipientEmail
            internalBookingRecipientEmails
            bookingConfirmationTemplateId
            bookingConfirmationInternalTemplateId
            bookingRequestConfirmationTemplateId
            bookingWaitlistConfirmationTemplateId
            bookingWaitlistContingentCheckConfirmationTemplateId
            bookingCustomRequestTemplateId
            bookingPassportDataReminderTemplateId
            previewTravelInterestTemplateId
            contactFormTemplateId
            esimInstallationInfoTemplateId
          }
          newsletterProvider @include(if: $withConversionTenantNewsletterProvider) {
            id
            provider
          }
          redirects @include(if: $withConversionTenantRedirects) {
            id
            fromType
            fromUrl
            toType
            toUrl
          }
          onlinePaymentConfig @include(if: $withConversionTenantOnlinePaymentConfig) {
            id
            enabled
            datatransMerchantId
            datatransMerchantPw
            ratioFibuAccountNo
            infoText
            datatransThemeConfig
          }
          ratioConfig @include(if: $withConversionTenantRatioConfig) {
            id
            adressgruppe
          }
          content @include(if: $withConversionTenantContent) {
            id
            bookingInsuranceInfo
            co2CompensationInfo
          }
          partnerTenants @include(if: $withConversionTenantPartnerTenants) {
            id
            filterCrossLinking
          }
        }
      }
      platform
      sentAt
      status
      errorMessage
    }
  }`

// language=GraphQL
export const UPDATE_CONVERSION_PLATFORM_SUBMISSION_MUTATION = `
  mutation Mutation($input: UpdateTrackingConversionPlatformSubmissionInput, $withConversion: Boolean = false, $withConversionTenant: Boolean = false, $withConversionTenantCms: Boolean = false, $withConversionTenantTravelTypes: Boolean = false, $withConversionTenantEmployees: Boolean = false, $withConversionTenantEmailConfig: Boolean = false, $withConversionTenantNewsletterProvider: Boolean = false, $withConversionTenantRedirects: Boolean = false, $withConversionTenantOnlinePaymentConfig: Boolean = false, $withConversionTenantRatioConfig: Boolean = false, $withConversionTenantContent: Boolean = false, $withConversionTenantPartnerTenants: Boolean = false) {
    conversionPlatformSubmission: updateTrackingConversionPlatformSubmission(input: $input) {
      id
      conversion @include(if: $withConversion) {
        id
        sessionId
        conversionName
        conversionTime
        conversionValue
        conversionCurrency
        tourName
        tourId
        bookingId
        landingPageUrl
        source
        medium
        utmSource
        utmMedium
        utmCampaign
        utmTerm
        utmContent
        gclid
        gbraid
        msclkid
        fbclid
        ttclid
        scclid
        liFatId
        acquisitionTimestamp
        tenant @include(if: $withConversionTenant) {
          id
          name
          slug
          domain
          externalReference
          cms @include(if: $withConversionTenantCms) {
            id
          }
          travelTypes @include(if: $withConversionTenantTravelTypes) {
            id
            name
            description
          }
          employees @include(if: $withConversionTenantEmployees) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          emailConfig @include(if: $withConversionTenantEmailConfig) {
            id
            defaultInternalRecipientEmail
            internalBookingRecipientEmails
            bookingConfirmationTemplateId
            bookingConfirmationInternalTemplateId
            bookingRequestConfirmationTemplateId
            bookingWaitlistConfirmationTemplateId
            bookingWaitlistContingentCheckConfirmationTemplateId
            bookingCustomRequestTemplateId
            bookingPassportDataReminderTemplateId
            previewTravelInterestTemplateId
            contactFormTemplateId
            esimInstallationInfoTemplateId
          }
          newsletterProvider @include(if: $withConversionTenantNewsletterProvider) {
            id
            provider
          }
          redirects @include(if: $withConversionTenantRedirects) {
            id
            fromType
            fromUrl
            toType
            toUrl
          }
          onlinePaymentConfig @include(if: $withConversionTenantOnlinePaymentConfig) {
            id
            enabled
            datatransMerchantId
            datatransMerchantPw
            ratioFibuAccountNo
            infoText
            datatransThemeConfig
          }
          ratioConfig @include(if: $withConversionTenantRatioConfig) {
            id
            adressgruppe
          }
          content @include(if: $withConversionTenantContent) {
            id
            bookingInsuranceInfo
            co2CompensationInfo
          }
          partnerTenants @include(if: $withConversionTenantPartnerTenants) {
            id
            filterCrossLinking
          }
        }
      }
      platform
      sentAt
      status
      errorMessage
    }
  }`

// language=GraphQL
export const DELETE_CONVERSION_PLATFORM_SUBMISSION_MUTATION = `
  mutation Mutation($input: DeleteTrackingConversionPlatformSubmissionInput) {
    deleteTrackingConversionPlatformSubmission(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CONVERSION_PLATFORM_SUBMISSION_MUTATION = `
  mutation Mutation($input: DeleteTrackingConversionPlatformSubmissionInput) {
    forceDeleteTrackingConversionPlatformSubmission(input: $input) {
      success
    }
  }`
